module.exports = __webpack_public_path__ + "6cf246a1beffdaef72219a64c2972abd.pdf";